import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/products/detail/page";
import KnowledgePage from "../pages/knowledge/page";
import ArticlePage from "../pages/knowledge/article/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/knowledge",
    element: <KnowledgePage />,
  },
  {
    path: "/knowledge/:id",
    element: <ArticlePage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
